module.exports = __webpack_public_path__ + "static/media/001.511f29e8.svg";